import { keepPreviousData, useQuery } from "@tanstack/react-query";
import {
  getThroughput,
  getThroughputInstances,
  type ThroughputInstancesParams,
  type ThroughputInstancesDto,
  type ThroughputParams,
  type ThroughputResponseDto,
} from "@/api/endpoints";

export function useThroughputQuery(params: ThroughputParams) {
  return useQuery<ThroughputResponseDto>({
    queryKey: ["requests", "throughput", params],
    queryFn: () => getThroughput(params),
    staleTime: 60_000,
    placeholderData: keepPreviousData,
  });
}

export function useThroughputInstancesQuery(params: ThroughputInstancesParams, enabled: boolean) {
  return useQuery<ThroughputInstancesDto>({
    queryKey: ["requests", "throughput", "instances", params],
    queryFn: () => getThroughputInstances(params),
    staleTime: 60_000,
    enabled,
    placeholderData: keepPreviousData,
  });
}
